import type { Value } from '../types.ts';

type Row = Record<string, Value>;
function object(value: Value): Row {
  if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Respuesta de CompartiComics inválida.');
  return value;
}
function volumes(group: Row): Row[] {
  if (!Array.isArray(group.volumes)) throw new Error('La colección no contiene tomos.');
  return group.volumes.map(object);
}
function integer(value: Value | undefined): string {
  const text = String(value);
  if (!/^-?\d+$/.test(text) || text === '0') throw new Error('ID de CompartiComics inválido.');
  return text;
}
function manga(group: Row): Value {
  const books = volumes(group);
  if (!books.length) throw new Error('Colección vacía.');
  const book = books[0];
  const id = group.cover_msg_id ? integer(group.cover_msg_id) : `-${integer(book.id)}`;
  return {
    title: String(book.title || book.filename || 'Sin título'),
    url: `https://comparticomics.lat/comic/${id}`,
    coverUrl: `https://comparticomics.lat/api/cover/${integer(group.cover_msg_id || book.cover_msg_id)}`,
    author: String(book.canonical_authors || book.author || ''),
    genres: [String(group.category || 'Cómic')],
    description: 'Tomos para descargar en CBR/CBZ/PDF desde CompartiComics. La lectura de estos archivos dentro de Yomiri todavía no está disponible. La descarga conserva las condiciones y límites del sitio original.',
  };
}
export function compartiCatalog(input: string): Value {
  const root = object(JSON.parse(input) as Value);
  if (!Array.isArray(root.results)) throw new Error('Catálogo de CompartiComics inválido.');
  return root.results.map(value => manga(object(value)));
}
export function compartiDetail(input: string): Value { return manga(object(JSON.parse(input) as Value)); }
export function compartiChapters(input: string): Value {
  return volumes(object(JSON.parse(input) as Value)).map((book, index) => ({
    name: `${index + 1}. ${String(book.filename || book.title || 'Tomo')} · Descargar archivo`,
    url: `https://comparticomics.lat/api/download/${integer(book.id)}`,
    ...(typeof book.indexed_at === 'string' ? { uploadDate: book.indexed_at } : {}),
  }));
}
